import Vue from 'vue';

const getInitialState = () => ({
  topNav: true,
  densityMapParameters: {
    type: '_all',
    dates: [],
  },
});

export const mutations = {
  set(state, { property, value }) {
    Vue.set(state, property, value);
  },

  setTopNav(state, { visible }) {
    state.topNav = visible;
  },

  setDensityMapParameters(state, { type, dates } : { type?: string, dates?: string[] }) {
    const assignObj = {} as any;

    if (type) assignObj.type = type;
    if (dates) assignObj.dates = dates;

    Vue.set(state, 'densityMapParameters', Object.assign(state.densityMapParameters, assignObj));
  },

  resetState(state) {
    Object.assign(state, getInitialState());
  },
};

export default {
  mutations,
  namespaced: true,
  state: getInitialState,
};
